/**
 * Monitoring & Tracking service page
 * Converted cyan/blue accents to orange
 */
import { Link } from 'react-router'
import { Button } from '../../components/ui/button'
import { Eye, BarChart, TrendingUp, CheckCircle } from 'lucide-react'

export default function MonitoringPage() {
  return (
    <div>
      <section className="bg-gradient-to-br from-orange-900 via-orange-800 to-orange-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold mb-6">Monitoring & Tracking</h1>
              <p className="text-sm text-orange-100 leading-relaxed mb-8">
                Edicoo uses  professional  monitoring program to comprehensively comprehend, track, and analyse broadcast content across traditional media platforms within Iraq. This sensitive process involves real-time monitoring of the top TV channels via our experienced Monitoring Department , as well as the specific TV channels utilized for our campaigns. 
                Our dedicated efforts extend beyond mere observation, as we carefully report on every aspect of campaign realization, encompassing in-depth competitor analyses. This comprehensive approach to media monitoring and reporting ensures that our clients receive detailed insights into the performance of their campaigns and the broader media landscape, enabling informed decision-making and strategic adjustments to further enhance their marketing endeavours.
              </p>
              <Button asChild size="lg" className="bg-orange-500 hover:bg-orange-600">
                <Link to="/contact">Track Your Success</Link>
              </Button>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/cbe32f06-171a-4824-89d1-9c41e64582d5.jpg" 
                alt="Marketing Analytics"
                className="w-full h-80 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Monitoring Services</h2>
              <div className="space-y-4">
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-orange-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Real-time Analytics</h3>
                    <p className="text-gray-600">Live campaign performance dashboards and alerts</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-orange-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Multi-Channel Tracking</h3>
                    <p className="text-gray-600">Unified tracking across all advertising channels</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-orange-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Performance Optimization</h3>
                    <p className="text-gray-600">Data-driven recommendations for campaign improvement</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-orange-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Detailed Reporting</h3>
                    <p className="text-gray-600">Comprehensive analytics reports and insights</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/74935056-3922-4553-a24b-441d3f3b0f94.jpg" 
                alt="Data Analytics"
                className="w-full h-96 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-orange-900 to-orange-700 text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6">Ready to Optimize Performance?</h2>
          <p className="text-xl text-orange-100 mb-8">
            Let us monitor and optimize your campaigns for maximum ROI and continuous improvement
          </p>
          <Button asChild size="lg" className="bg-white text-orange-700 hover:bg-orange-50 text-lg px-8">
            <Link to="/contact">Start Monitoring</Link>
          </Button>
        </div>
      </section>
    </div>
  )
}
